/* @flow */
import * as React from "react";
import prefixStyles from "../utils/prefixStyles";
import { THROTTLE_DELAY } from "./SliderController";

type Props = {
  color: ?string,
  size: number,
};

export default class Bar extends React.Component<Props> {
  static defaultProps = {
    color: "#BDBDBD",
  };

  render() {
    const { color, size } = this.props;
    const style = prefixStyles({
      backgroundColor: color,
      flexGrow: size,
      transition: `flex-grow ${THROTTLE_DELAY}ms ease-in-out`,
      height: 2,
    });

    return <div data-component-name="Bar" style={style} />;
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Slider/Bar.jsx